(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[16],{

/***/ "0x7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Yd/I");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("1JJ2");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3uBn");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */










var Toast = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"])(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE_WAVE : _ref$color,
      icon = _ref.icon,
      _ref$isFixed = _ref.isFixed,
      isFixed = _ref$isFixed === void 0 ? false : _ref$isFixed,
      label = _ref.label,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_6__[/* BEFORE_APP */ "c"] : _ref$portalName,
      visible = _ref.visible,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "color", "icon", "isFixed", "label", "onClose", "portalName", "visible"]);

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], {
    name: portalName
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('end-0 top-0 isolate z-8 overflow-x-hidden py-20', {
      absolute: !isFixed,
      fixed: isFixed,
      'pointer-events-none': !visible,
      'px-20': visible
    }, className)
  }, __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    "aria-hidden": !visible,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('transform transition-all duration-250 ease-in', {
      'pointer-events-auto ltr:translate-x-full rtl:-translate-x-full': !visible,
      'translate-x-0': visible
    })
  }), __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex rounded-12 bg-white font-bold', "text-".concat(color), {
      'shadow-md': visible
    }),
    "data-testid": "Toast",
    ref: ref
  }, __jsx("div", {
    className: "flex flex-1 items-center gap-5 p-10"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
    className: "shrink-0",
    name: icon,
    width: "1.875rem"
  }), label && __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_11__[/* Text */ "a"], {
    className: "flex-1",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])(label)
  }), children), __jsx("button", {
    "aria-disabled": !visible,
    className: "shrink-0 border-s-1 border-lightGrey p-10 text-black transition-colors duration-250 ease-in hocus:text-black-active",
    onClick: onClose,
    tabIndex: visible ? 0 : -1,
    type: "button"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CROSS,
    width: "0.625rem"
  }))))));
});

/***/ }),

/***/ "2hfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MORNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AFTERNOON_BEFORE_5PM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AFTERNOON_AFTER_5PM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AFTERNOON_BEFORE_4PM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AFTERNOON_AFTER_4PM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AFTERNOON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RENTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSlotKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAttendeeLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return activityOrEquipementDetailClick; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KL6I");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_string_string_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tX1K");
/* harmony import */ var _utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("E8Xq");








var MORNING = 'MORNING';
var AFTERNOON_BEFORE_5PM = 'AFTERNOON_BEFORE_5PM';
var AFTERNOON_AFTER_5PM = 'AFTERNOON_AFTER_5PM';
var AFTERNOON_BEFORE_4PM = 'AFTERNOON_BEFORE_4PM';
var AFTERNOON_AFTER_4PM = 'AFTERNOON_AFTER_4PM'; // childcares

var AFTERNOON = 'AFTERNOON';
var RENTAL = 'RENTAL';
var getSlotKey = function getSlotKey(_ref) {
  var slotName = _ref.slotName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      attendeeId = _ref.attendeeId;
  return "".concat(slotName, "-").concat(startDate, "-").concat(endDate, "-").concat(attendeeId);
};
var getAttendeeLabel = function getAttendeeLabel(attendeesList, attendeeId, appContext) {
  var _ref2 = attendeesList.find(function (_ref3) {
    var id = _ref3.id;
    return id === attendeeId;
  }) || {},
      unicodeFirstName = _ref2.unicodeFirstName,
      firstName = _ref2.firstName,
      unicodeLastName = _ref2.unicodeLastName,
      lastName = _ref2.lastName,
      birthdate = _ref2.birthdate,
      isChild = _ref2.isChild;

  var attendeeFirstName = (unicodeFirstName === null || unicodeFirstName === void 0 ? void 0 : unicodeFirstName.trim()) || Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_7__[/* capitalizeWordFirstCaracter */ "c"])((firstName === null || firstName === void 0 ? void 0 : firstName.trim()) || '');
  var attendeeLastName = (unicodeLastName === null || unicodeLastName === void 0 ? void 0 : unicodeLastName.trim()) || Object(_utils_string_stringUtils__WEBPACK_IMPORTED_MODULE_7__[/* capitalizeWordFirstCaracter */ "c"])((lastName === null || lastName === void 0 ? void 0 : lastName.trim()) || '');
  var attendeelabel = "".concat(String(attendeeFirstName)).concat(attendeeFirstName ? ' ' : '').concat(String(attendeeLastName));

  if (attendeelabel && Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_4__[/* isSeller */ "f"])(appContext) && isChild && birthdate) {
    attendeelabel += " (".concat(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* formatApiDate */ "g"])(birthdate, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.dateFormatTechnicalID')), ")");
  }

  return isChild && birthdate && !attendeelabel ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.services.childcare.forWhatKid', {
    birthdate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* formatApiDate */ "g"])(birthdate, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.dateFormatTechnicalID'))
  }) : attendeelabel || "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])(!isChild ? 'booking.common.adult' : 'booking.common.child'), " ").concat(Object(_utils_string_string_util__WEBPACK_IMPORTED_MODULE_6__[/* upperCaseLetterToInt */ "e"])(attendeeId));
};
var activityOrEquipementDetailClick = function activityOrEquipementDetailClick(isCancellingActivity, isRental) {
  if (isRental) {
    return isCancellingActivity ? 'remove_ski_equipment' : 'add_ski_equipment';
  }

  return isCancellingActivity ? 'remove_activity' : 'add_activity';
};

/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var ImageSlideShow = function ImageSlideShow(_ref) {
  var centerPadding = _ref.centerPadding,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasOverlappingClick = _ref.hasOverlappingClick,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasLazyLoading = _ref.hasLazyLoading,
      itemClassName = _ref.itemClassName,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"], {
      altMsg: alt,
      className: itemClassName,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__[/* SliderHandler */ "a"], {
    centerPadding: centerPadding,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('group relative', className)
    }, itemsNode, hasControls && __jsx("div", {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-none absolute inset-0 z-2 m-auto flex w-full items-center justify-between transition-opacity duration-250 ease-in will-change-transform', {
        'px-10 sm:px-20': !hasOverlappingControls
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-auto z-2 me-auto shadow-sm', {
        '-translate-x-1/2 transform': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: function onClick(event) {
        onPrevious(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      }
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('pointer-events-auto z-2 ms-auto shadow-sm', {
        'translate-x-1/2 transform': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: function onClick(event) {
        onNext(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      },
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-10 sm:px-20"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "pointer-events-auto z-2 me-auto shadow-sm",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: function onClick(event) {
        onPrevious(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      }
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "pointer-events-auto z-2 ms-auto shadow-sm",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: function onClick(event) {
        onNext(event);

        if (hasOverlappingClick) {
          event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
      },
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "FtaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useAbTasty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storeAbTastyEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAbTastyEvent; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zygG");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kD1E");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ub5k");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("d1HQ");
/* harmony import */ var _session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("9NGo");
/* harmony import */ var _session_storage_api_sessionStorage_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("4paF");















var sendTransaction = function sendTransaction(_ref) {
  var id = _ref.id,
      affiliation = _ref.affiliation,
      revenue = _ref.revenue,
      currency = _ref.currency;
  var timeLimit = moment__WEBPACK_IMPORTED_MODULE_8___default()().add(5, 's');
  var waiter = setInterval(function () {
    var _window, _window$abtasty;

    if ((_window = window) === null || _window === void 0 ? void 0 : (_window$abtasty = _window.abtasty) === null || _window$abtasty === void 0 ? void 0 : _window$abtasty.send) {
      window.abtasty.send('transaction', {
        tid: id,
        // Transaction ID
        ta: affiliation,
        // Transaction Affiliation
        tr: revenue,
        // Transaction Revenue
        tc: currency // Transaction Currency

      });
      clearInterval(waiter);
    } else if (moment__WEBPACK_IMPORTED_MODULE_8___default()().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};

var getABTastyId = function getABTastyId(abtasty, _ref2) {
  var isCmta = _ref2.isCmta,
      isCxo = _ref2.isCxo;

  if (isCmta && abtasty.cmta) {
    return abtasty.cmta.id;
  }

  if (isCxo && abtasty.cxo) {
    return abtasty.cxo.id;
  }

  return abtasty.id;
};

var useAbTasty = function useAbTasty() {
  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__[/* useAppContext */ "c"])(),
      isCmta = _useAppContext.isCmta,
      isCxo = _useAppContext.isCxo,
      locale = _useAppContext.locale;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_9__["useRouter"])(),
      queryParams = _useRouter.query;

  var _getConfigWithNoThird = Object(_third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_10__[/* getConfigWithNoThirdPartySupport */ "a"])({
    locale: locale,
    name: 'tracking',
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      abtasty = _getConfigWithNoThird.abtasty;

  var abTastyId = getABTastyId(abtasty, {
    isCmta: isCmta,
    isCxo: isCxo
  });
  var isAbTastyActive = Boolean(enabled && (abtasty === null || abtasty === void 0 ? void 0 : abtasty.enabled) && (abtasty === null || abtasty === void 0 ? void 0 : abtasty.host) && abTastyId);
  var abTastyScriptUrl = isAbTastyActive ? "https://".concat(abtasty.host, "/").concat(abTastyId, ".js") : '';
  return {
    abTastyScriptUrl: abTastyScriptUrl,
    isAbTastyActive: isAbTastyActive
  };
};
var storeAbTastyEvent = function storeAbTastyEvent() {
  var _getDataLayer = Object(_tracking_tracking_api__WEBPACK_IMPORTED_MODULE_12__[/* getDataLayer */ "a"])(),
      google = _getDataLayer.google;

  var abTastyEventsToStore = {};
  var abTastyEvents = google === null || google === void 0 ? void 0 : google.filter(function (event) {
    return event.event === 'ab_tasty';
  });
  abTastyEvents.forEach(function (abTastyEvent) {
    for (var _i = 0, _Object$entries = Object.entries(abTastyEvent); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key.includes('ab_tasty')) {
        abTastyEventsToStore[key] = value;
      }
    }
  });
  Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_13__[/* setInSessionStorage */ "d"])(_session_storage_api_sessionStorage_constants__WEBPACK_IMPORTED_MODULE_14__[/* KEY_BE_ABTASTY_EVENTS */ "a"], abTastyEventsToStore);
};
var getAbTastyEvent = function getAbTastyEvent() {
  return Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_13__[/* getFromSessionStorage */ "b"])(_session_storage_api_sessionStorage_constants__WEBPACK_IMPORTED_MODULE_14__[/* KEY_BE_ABTASTY_EVENTS */ "a"]) || {};
};

/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag_Tag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js

var themes = {
  "default": {
    thRoot: Object(classnames_utils["a" /* classnames */])('border-saffron bg-saffron text-black', 'inline-flex items-center gap-5 overflow-hidden whitespace-nowrap rounded-pill px-10 py-5 font-sans text-12 font-bold leading-1')
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx


var __jsx = react_default.a.createElement;




var Tag_Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      iconName = _ref.iconName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "iconName", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    name: iconName,
    width: "1em"
  }), children);
};

/***/ }),

/***/ "RTMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TransportDetails; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/be-transport-details/BeTransportDetails.themes.js
var BeTransportDetails_themes = __webpack_require__("vvV4");

// EXTERNAL MODULE: ./src/client/components/widgets/transport-details/transportUtils.js
var transportUtils = __webpack_require__("z8xc");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/utils/transport/transportUtils.js
var transport_transportUtils = __webpack_require__("pdPG");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsCompanyLogo.jsx
var __jsx = react_default.a.createElement;





var SNCF_ID = 'SNC';
var TransportDetailsCompanyLogo_TransportDetailsCompanyLogo = function TransportDetailsCompanyLogo(_ref) {
  var companyOperator = _ref.companyOperator,
      manyCompanies = _ref.manyCompanies,
      theme = _ref.theme;
  var _themes$theme = Object(BeTransportDetails_themes["a" /* themes */])()[theme],
      thCompanyLogo = _themes$theme.thCompanyLogo,
      thManyCompanies = _themes$theme.thManyCompanies;
  var companyHasLogo = !!companyOperator.logo;
  return __jsx("div", {
    className: thCompanyLogo,
    "data-testid": "TransportDetailsCompanyLogo"
  }, manyCompanies || !companyHasLogo ? __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex justify-center rounded-8 bg-pearl', thManyCompanies)
  }, __jsx(Icon["a" /* Icon */], {
    className: "-my-5 text-lightGrey",
    name: icons["a" /* ICONS */].MULTIPLE_COMPANIES,
    width: "2rem"
  })) : __jsx("img", {
    src: companyOperator.logo // SNCF logo is shaped differently than other logos and should have a specific width
    ,
    width: companyOperator.id === SNCF_ID ? 65 : 110,
    alt: companyOperator.label
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsItinerary.jsx


var TransportDetailsItinerary_jsx = react_default.a.createElement;







function TransportDetailsItinerary(_ref) {
  var theme = _ref.theme,
      transportDetailEnriched = _ref.transportDetailEnriched;
  var departureTime = Object(transportUtils["h" /* formatTime */])(transportDetailEnriched.departure.time || '', Object(src_i18n["h" /* t */])('common.timeFormat')) || '';
  var arrivalTime = Object(transportUtils["h" /* formatTime */])(transportDetailEnriched.arrival.time || '', Object(src_i18n["h" /* t */])('common.timeFormat')) || '';
  var departureLabel = Object(labelUtils["a" /* capitalizeName */])(transportDetailEnriched.departure.airportLabel);
  var arrivalLabel = Object(labelUtils["a" /* capitalizeName */])(transportDetailEnriched.arrival.airportLabel);
  var arrivalDaysAfter = Object(transportUtils["k" /* getDiffAbsoluteDays */])(transportDetailEnriched.departure.date, transportDetailEnriched.arrival.date);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var thItinerary = Object(BeTransportDetails_themes["a" /* themes */])()[theme].thItinerary;
  return TransportDetailsItinerary_jsx("div", {
    className: "flex w-full",
    "data-testid": "TransportDetailsItinerary"
  }, TransportDetailsItinerary_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex-none text-end', thItinerary)
  }, TransportDetailsItinerary_jsx("p", {
    className: "text-16 font-semibold leading-normal"
  }, departureTime), TransportDetailsItinerary_jsx("p", {
    className: "invisible text-12"
  }, "(", Object(src_i18n["h" /* t */])('common.transport.localHour'), ")"), TransportDetailsItinerary_jsx("p", {
    style: !departureTime ? {
      marginTop: '22px'
    } : {},
    className: "text-14 leading-1"
  }, departureLabel)), TransportDetailsItinerary_jsx("div", {
    className: "grow px-10 pt-[28px] text-center"
  }, Number(transportDetailEnriched.durationInMin) > 0 ? TransportDetailsItinerary_jsx("p", {
    className: "text-12 leading-1 text-mediumGrey"
  }, Object(transportUtils["p" /* transformMinutesInHours */])(transportDetailEnriched.durationInMin || 0, isRTL)) : TransportDetailsItinerary_jsx("div", {
    className: "pt-10"
  }), transportDetailEnriched.stops > 0 ? TransportDetailsItinerary_jsx("div", {
    className: "my-10 flex w-full items-center"
  }, TransportDetailsItinerary_jsx("div", {
    className: "w-full rounded-l-24 border-b border-t border-solid border-lightGrey"
  }), TransportDetailsItinerary_jsx("div", {
    className: "mx-2 rounded-full border-2 border-solid border-orange"
  }), TransportDetailsItinerary_jsx("div", {
    className: "w-full rounded-r-24 border-b border-t border-solid border-lightGrey"
  })) : TransportDetailsItinerary_jsx("div", {
    className: "my-10 w-full rounded-24 border-b border-t border-solid border-lightGrey"
  }), transportDetailEnriched.stops > 0 ? TransportDetailsItinerary_jsx("p", {
    className: "text-12 leading-1 text-orange"
  }, "".concat(transportDetailEnriched.stops, " ").concat(Object(src_i18n["h" /* t */])('common.transport.connection'))) : TransportDetailsItinerary_jsx("p", {
    className: "text-12 leading-1 text-green"
  }, Object(src_i18n["h" /* t */])('common.transport.direct'))), TransportDetailsItinerary_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex-none', thItinerary)
  }, TransportDetailsItinerary_jsx("div", {
    className: "flex items-center gap-4 leading-normal"
  }, TransportDetailsItinerary_jsx("span", {
    className: "text-16 font-semibold"
  }, arrivalTime), arrivalDaysAfter !== null && arrivalDaysAfter > 0 && TransportDetailsItinerary_jsx("span", {
    "data-testid": "TransportDetailsItineraryArrivalDaysAfter",
    className: "h-full rounded-pill bg-sienna px-10 py-2 text-12 font-bold text-white"
  }, "+", theme === 'mobile' ? arrivalDaysAfter : Object(src_i18n["h" /* t */])('common.dateTime.day', {
    count: arrivalDaysAfter
  }))), TransportDetailsItinerary_jsx("p", {
    className: "text-12"
  }, "(", Object(src_i18n["h" /* t */])('common.transport.localHour'), ")"), TransportDetailsItinerary_jsx("p", {
    style: !arrivalTime ? {
      marginTop: '22px'
    } : {},
    className: "text-14 leading-1"
  }, arrivalLabel)));
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsOperator.jsx

var TransportDetailsOperator_jsx = react_default.a.createElement;










var TransportDetailsOperator_OperatorTooltip = function OperatorTooltip(_ref) {
  var className = _ref.className;
  return TransportDetailsOperator_jsx(Tooltip["a" /* Tooltip */], {
    modalProps: {
      closeLabel: Object(src_i18n["h" /* t */])('common.close'),
      size: 'small',
      children: null
    },
    renderTrigger: function renderTrigger(toggle) {
      return TransportDetailsOperator_jsx("button", {
        className: Object(classnames_utils["a" /* classnames */])('relative ml-2', className),
        onClick: toggle,
        type: "button"
      }, TransportDetailsOperator_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].INFORMATION,
        width: "1.25rem"
      }));
    }
  }, TransportDetailsOperator_jsx(Text["a" /* Text */], {
    className: "mb-10 p-20 text-12",
    text: Object(src_i18n["h" /* t */])('common.transport.operatedByInfo')
  }));
};

var TransportDetailsOperator_TransportDetailsOperator = function TransportDetailsOperator(_ref2) {
  var _transportDetailEnric, _transportDetailEnric2, _transportDetailEnric3, _transportDetailEnric4;

  var theme = _ref2.theme,
      transportDetailEnriched = _ref2.transportDetailEnriched,
      companyOperatorsName = _ref2.companyOperatorsName;
  var _themes$theme = Object(BeTransportDetails_themes["a" /* themes */])()[theme],
      thOperator = _themes$theme.thOperator,
      thOperatorInfoButton = _themes$theme.thOperatorInfoButton;
  var isSameOperatorAndExploiter = ((_transportDetailEnric = transportDetailEnriched.transport.companyOperator) === null || _transportDetailEnric === void 0 ? void 0 : _transportDetailEnric.id) === ((_transportDetailEnric2 = transportDetailEnriched.transport.companyExploiter) === null || _transportDetailEnric2 === void 0 ? void 0 : _transportDetailEnric2.id);
  return TransportDetailsOperator_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-4/5 gap-4 text-14 font-semibold', thOperator),
    "data-testid": "TransportDetailsOperator"
  }, companyOperatorsName.length > 1 ? TransportDetailsOperator_jsx("div", null, companyOperatorsName.join(' - ')) : TransportDetailsOperator_jsx(react_default.a.Fragment, null, TransportDetailsOperator_jsx("div", null, Object(labelUtils["a" /* capitalizeName */])((_transportDetailEnric3 = transportDetailEnriched.transport.companyExploiter) === null || _transportDetailEnric3 === void 0 ? void 0 : _transportDetailEnric3.label)), !isSameOperatorAndExploiter && TransportDetailsOperator_jsx(react_default.a.Fragment, null, TransportDetailsOperator_jsx("span", null, Object(src_i18n["h" /* t */])('booking.transport.planeTicket.operatedBy'), "\xA0", Object(labelUtils["a" /* capitalizeName */])((_transportDetailEnric4 = transportDetailEnriched.transport.companyOperator) === null || _transportDetailEnric4 === void 0 ? void 0 : _transportDetailEnric4.label)), TransportDetailsOperator_jsx(TransportDetailsOperator_OperatorTooltip, {
    className: thOperatorInfoButton
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTransportInfos.jsx





var TransportDetailsTransportInfos_jsx = react_default.a.createElement;







var TransportDetailsTransportInfos_TransportDetailsTransportInfos = function TransportDetailsTransportInfos(_ref) {
  var theme = _ref.theme,
      transportDetailEnriched = _ref.transportDetailEnriched;
  var _themes$theme = Object(BeTransportDetails_themes["a" /* themes */])()[theme],
      thTransportInfos = _themes$theme.thTransportInfos,
      thLuggage = _themes$theme.thLuggage;
  var transportClasses = Object(transportUtils["l" /* getTransportClasses */])(transportDetailEnriched.travelSections);
  var isTrain = transportDetailEnriched.travelSections.some(function (el) {
    return el.transport.type === transportUtils["d" /* TRAIN */];
  });
  var hasNoBagageWeithAndQuantity = !transportDetailEnriched.transport.baggage.weight && !transportDetailEnriched.transport.baggage.quantity;
  var baggageWeight = transportDetailEnriched.transport.baggage.weight;
  var baggageQuantity = transportDetailEnriched.transport.baggage.quantity;
  var baggageWeightUnit = transportDetailEnriched.transport.baggage.unit;
  return TransportDetailsTransportInfos_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('items-center text-12', thTransportInfos),
    "data-testid": "TransportDetailsTransportInfos"
  }, TransportDetailsTransportInfos_jsx("span", {
    className: "mr-5"
  }, isTrain ? Object(src_i18n["h" /* t */])('common.transport.train') : Object(src_i18n["h" /* t */])('common.transport.flight'), "\xA0", transportDetailEnriched.stops > 0 ? Object(src_i18n["h" /* t */])('common.transport.connection') : Object(src_i18n["h" /* t */])('common.transport.direct'), transportClasses.length > 0 && ','), transportClasses.length > 0 && TransportDetailsTransportInfos_jsx("span", {
    className: "mr-5"
  }, Object(src_i18n["h" /* t */])('common.transport.transportClass.classLabel'), "\xA0", transportClasses.map(function (transportClass) {
    return Object(src_i18n["h" /* t */])("common.transport.transportClass.".concat(transportUtils["f" /* TRANSPORT_CLASS_TO_I18N */][transportClass]));
  }).join(', ')), !hasNoBagageWeithAndQuantity && TransportDetailsTransportInfos_jsx(react_default.a.Fragment, null, TransportDetailsTransportInfos_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('rounded-full border-l border-r border-solid border-lightGrey', thLuggage)
  }), TransportDetailsTransportInfos_jsx("div", {
    className: "flex items-center gap-4"
  }, TransportDetailsTransportInfos_jsx(Icon["a" /* Icon */], {
    className: "relative top-[-1px] flex items-center ps-1 text-black",
    dataTestid: "baggage-icon",
    id: "baggage-icon",
    name: icons["a" /* ICONS */].BAGGAGE,
    width: "17px"
  }), TransportDetailsTransportInfos_jsx("span", {
    "data-testid": "weightAndQuantity"
  }, "".concat(Object(src_i18n["h" /* t */])('common.transport.weightPerPersonLabel', {
    baggageQuantity: baggageQuantity ? "(x".concat(baggageQuantity, ") ") : '',
    baggageWeight: baggageWeight ? "(".concat(baggageWeight).concat(Number(baggageWeight) ? baggageWeightUnit : '', ") ") : ''
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTravelDates.jsx

var TransportDetailsTravelDates_jsx = react_default.a.createElement;



function TransportDetailsTravelDates(_ref) {
  var _transportDetailEnric, _transportDetailEnric2;

  var transportDetailEnriched = _ref.transportDetailEnriched,
      isInbound = _ref.isInbound;
  var wayLabel = isInbound ? Object(src_i18n["h" /* t */])('booking.transport.inbound') : Object(src_i18n["h" /* t */])('booking.transport.outbound');
  var arrivalDaysAfter = Object(transportUtils["k" /* getDiffAbsoluteDays */])((_transportDetailEnric = transportDetailEnriched.departure) === null || _transportDetailEnric === void 0 ? void 0 : _transportDetailEnric.date, (_transportDetailEnric2 = transportDetailEnriched.arrival) === null || _transportDetailEnric2 === void 0 ? void 0 : _transportDetailEnric2.date);
  return TransportDetailsTravelDates_jsx("div", {
    className: "flex text-14 mb-2",
    "data-testid": "TransportDetailsTravelDates"
  }, TransportDetailsTravelDates_jsx("p", {
    className: "font-semibold"
  }, wayLabel), "\xA0", TransportDetailsTravelDates_jsx("span", null, Object(transportUtils["g" /* formatDate */])(transportDetailEnriched.departure.date, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.dateFormat')), arrivalDaysAfter ? TransportDetailsTravelDates_jsx(react_default.a.Fragment, null, "\xA0", TransportDetailsTravelDates_jsx("span", {
    className: "text-sienna font-semibold"
  }, "(".concat(Object(src_i18n["h" /* t */])('booking.transport.arrivalNextDay'), " ").concat(Object(transportUtils["g" /* formatDate */])(transportDetailEnriched.arrival.date, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.dateFormat')), ")"))) : null));
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/cms/cms.selector.js


var cmsSelector = function cmsSelector(_ref) {
  var cms = _ref.cms;
  return cms || {};
};

var i18nSelector = Object(reselect_lib["createSelector"])(cmsSelector, function (i18n) {
  return i18n || {};
});

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsWarning.jsx




var TransportDetailsWarning_jsx = react_default.a.createElement;









var TransportDetailsWarning_TransportDetailsWarning = function TransportDetailsWarning(_ref) {
  var transportDetailEnriched = _ref.transportDetailEnriched;
  var i18n = Object(es["e" /* useSelector */])(i18nSelector);
  var legalInfos = Object(ContactInfoUtils["m" /* getOptinsInfos */])(i18n === null || i18n === void 0 ? void 0 : i18n.bookingProcess);
  var theo = legalInfos.theo,
      webTheo = legalInfos.webTheo,
      ndc = legalInfos.ndc;
  var isCharter = transportDetailEnriched.travelSections.every(function (_ref2) {
    var isClubmedTransport = _ref2.isClubmedTransport;
    return isClubmedTransport;
  });
  var isTrain = transportDetailEnriched.travelSections.find(function (el) {
    return el.transport.type === transportUtils["d" /* TRAIN */];
  });

  if (isCharter && !isTrain) {
    return TransportDetailsWarning_jsx(Notification["a" /* Notification */], {
      className: "my-10 w-full px-20 py-10 text-black",
      "data-testid": "voyageNotification",
      iconWidth: "1.5rem"
    }, TransportDetailsWarning_jsx(Text["a" /* Text */], {
      className: "text-black",
      text: Object(src_i18n["h" /* t */])('booking.transport.charterTransportLabel'),
      theme: "text-sans-n1"
    }));
  }

  if ((transportDetailEnriched === null || transportDetailEnriched === void 0 ? void 0 : transportDetailEnriched.cancellationPolicyType) === constants["e" /* LEGAL_INFO_WEBTHEO_ID */] && !!webTheo) {
    var webTheoDescription = webTheo.description,
        webTheoTitle = webTheo.title;
    return TransportDetailsWarning_jsx(Notification["a" /* Notification */], {
      className: "my-10 w-full px-20 py-10 text-black",
      "data-testid": "TheoCancellationPolicyNotification",
      iconWidth: "1.5rem"
    }, TransportDetailsWarning_jsx("div", {
      className: "text-14 font-semibold"
    }, webTheoTitle), TransportDetailsWarning_jsx(Text["a" /* Text */], {
      className: "text-black",
      text: webTheoDescription,
      theme: "text-sans-n1"
    }));
  }

  if ((transportDetailEnriched === null || transportDetailEnriched === void 0 ? void 0 : transportDetailEnriched.cancellationPolicyType) === constants["d" /* LEGAL_INFO_THEO_ID */] && !!theo) {
    var theoDescription = theo.description,
        theoTitle = theo.title;
    return TransportDetailsWarning_jsx(Notification["a" /* Notification */], {
      className: "my-10 w-full px-20 py-10 text-black",
      "data-testid": "TheoCancellationPolicyNotification",
      iconWidth: "1.5rem"
    }, TransportDetailsWarning_jsx("div", {
      className: "text-14 font-semibold"
    }, theoTitle), TransportDetailsWarning_jsx(Text["a" /* Text */], {
      className: "text-black",
      text: theoDescription,
      theme: "text-sans-n1"
    }));
  }

  if ((transportDetailEnriched === null || transportDetailEnriched === void 0 ? void 0 : transportDetailEnriched.cancellationPolicyType) === constants["c" /* LEGAL_INFO_NDC_ID */] && !!ndc) {
    var ndcDescription = ndc.description,
        ndcTitle = ndc.title;
    return TransportDetailsWarning_jsx(Notification["a" /* Notification */], {
      className: "my-10 w-full px-20 py-10 text-black",
      "data-testid": "ndcPolicyType",
      iconWidth: "1.5rem"
    }, TransportDetailsWarning_jsx("div", {
      className: "text-14 font-semibold"
    }, ndcTitle), TransportDetailsWarning_jsx(Text["a" /* Text */], {
      className: "text-black",
      text: ndcDescription,
      theme: "text-sans-n1"
    }));
  }

  return null;
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTravelSectionBound.jsx

var TransportDetailsTravelSectionBound_jsx = react_default.a.createElement;




function TransportDetailsTravelSectionBound(_ref) {
  var isDeparture = _ref.isDeparture,
      travelSectionBound = _ref.travelSectionBound,
      firstDeparture = _ref.firstDeparture;
  var time = Object(transportUtils["h" /* formatTime */])(travelSectionBound.time || '', Object(src_i18n["h" /* t */])('common.timeFormat')) || '';
  var label = Object(labelUtils["a" /* capitalizeName */])(travelSectionBound.airportLabel || travelSectionBound.label);
  var daysAfter = Object(transportUtils["k" /* getDiffAbsoluteDays */])(firstDeparture.date, travelSectionBound.date);
  var terminal = travelSectionBound.terminalCode ? Object(src_i18n["h" /* t */])('common.transport.terminalCode', {
    terminalcode: travelSectionBound.terminalCode
  }) : null;
  return TransportDetailsTravelSectionBound_jsx("div", {
    "data-testid": "TransportDetailsTravelSectionBound",
    className: "flex items-start gap-20"
  }, TransportDetailsTravelSectionBound_jsx("p", {
    className: "text-16 font-semibold leading-normal"
  }, time), TransportDetailsTravelSectionBound_jsx("div", null, TransportDetailsTravelSectionBound_jsx("p", {
    className: "text-16 font-semibold leading-normal"
  }, label), daysAfter ? TransportDetailsTravelSectionBound_jsx("span", {
    className: "text-12 font-semibold text-sienna"
  }, "(".concat(Object(src_i18n["h" /* t */])("booking.transport.".concat(isDeparture ? 'departureNextDay' : 'arrivalNextDay')), " ").concat(Object(transportUtils["g" /* formatDate */])(travelSectionBound.date, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.dateFormat')), ")")) : null, terminal && TransportDetailsTravelSectionBound_jsx("p", {
    className: "text-12 font-normal"
  }, terminal)));
}
// EXTERNAL MODULE: ./src/client/components/widgets/copy-button/CopyButton.jsx
var CopyButton = __webpack_require__("wKck");

// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTravelSectionReference.jsx
var TransportDetailsTravelSectionReference_jsx = react_default.a.createElement;






var TransportDetailsTravelSectionReference_getLabel = function getLabel(type) {
  switch (type) {
    case transportUtils["a" /* BOAT */]:
      return 'common.transport.pnrBoatTutorial';

    case transportUtils["d" /* TRAIN */]:
      return 'common.transport.pnrTrainTutorial';

    default:
      return 'common.transport.pnrTutorial';
  }
};

var TransportDetailsTravelSectionReference_TransportDetailsTravelSectionReference = function TransportDetailsTravelSectionReference(_ref) {
  var _attendees$;

  var _ref$attendees = _ref.attendees,
      attendees = _ref$attendees === void 0 ? [] : _ref$attendees,
      className = _ref.className,
      onClickCopy = _ref.onClickCopy,
      type = _ref.type;

  if (!(attendees === null || attendees === void 0 ? void 0 : attendees.length)) {
    return null;
  }

  var reference = attendees === null || attendees === void 0 ? void 0 : (_attendees$ = attendees[0]) === null || _attendees$ === void 0 ? void 0 : _attendees$.pnr;

  if (!reference) {
    return null;
  }

  return TransportDetailsTravelSectionReference_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('space-y-10 rounded-12 border-1 border-lightGrey bg-white p-20', className)
  }, TransportDetailsTravelSectionReference_jsx("p", {
    className: "text-16 font-bold"
  }, Object(src_i18n["h" /* t */])('common.transport.pnrReferenceNumber')), TransportDetailsTravelSectionReference_jsx("p", {
    className: "text-14"
  }, Object(src_i18n["h" /* t */])(TransportDetailsTravelSectionReference_getLabel(type))), TransportDetailsTravelSectionReference_jsx(CopyButton["a" /* CopyButton */], {
    copiedLabel: Object(src_i18n["h" /* t */])('common.transport.pnrCopied'),
    onClick: onClickCopy
  }, reference));
};
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTravelSectionStop.jsx

var TransportDetailsTravelSectionStop_jsx = react_default.a.createElement;







function TransportDetailsTravelSectionStop(_ref) {
  var type = _ref.type,
      durationInMin = _ref.durationInMin;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var stop = durationInMin ? Object(transportUtils["p" /* transformMinutesInHours */])(durationInMin, isRTL) : null;
  return TransportDetailsTravelSectionStop_jsx("div", {
    "data-testid": "TransportDetailsTravelSectionStop",
    className: Object(classnames_utils["a" /* classnames */])('my-20 rounded-12 border-1 border-grey px-20 py-10', Object(defineProperty["a" /* default */])({}, 'border-orange', type !== 'technicalStop'))
  }, TransportDetailsTravelSectionStop_jsx("div", {
    className: "flex items-center gap-20 text-14 leading-tight"
  }, stop && TransportDetailsTravelSectionStop_jsx("span", {
    className: "text-orange"
  }, stop), type === 'technicalStop' ? TransportDetailsTravelSectionStop_jsx("span", {
    className: "font-semibold text-black"
  }, Object(src_i18n["h" /* t */])('common.transport.technicalStop')) : TransportDetailsTravelSectionStop_jsx("span", {
    className: "text-orange"
  }, Object(src_i18n["h" /* t */])('common.transport.connection'))), type === 'connection' && TransportDetailsTravelSectionStop_jsx("div", {
    className: "mt-10 flex items-center gap-20"
  }, TransportDetailsTravelSectionStop_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-orange",
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.5rem"
  }), TransportDetailsTravelSectionStop_jsx("span", {
    className: "text-14 leading-tight text-orange"
  }, Object(src_i18n["h" /* t */])('booking.transport.stopoverAirportChange'))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTravelSection.jsx


var TransportDetailsTravelSection_jsx = react_default.a.createElement;











function computeTransportLabel(transport) {
  var transportClass = transport.class ? "".concat(Object(src_i18n["h" /* t */])("common.transport.transportClass.".concat(transportUtils["f" /* TRANSPORT_CLASS_TO_I18N */][transport.class])), " - ") : '';
  var reference = "".concat(transport.reference || transport.travelNumber || '');
  var flightNumber = "".concat(transport.companyOperator.id, " ").concat(reference);
  var companyName = Object(labelUtils["a" /* capitalizeName */])(transport.companyOperator.label);
  var vehicleName = transport.vehicleType ? Object(labelUtils["a" /* capitalizeName */])(transport.vehicleType) : null;
  return "".concat(transportClass).concat(flightNumber, " ").concat(companyName).concat(vehicleName ? " - ".concat(vehicleName) : '');
}

var transportTypeToIcon = {
  TRAIN: icons["a" /* ICONS */].TRAIN,
  PLANE: icons["a" /* ICONS */].PLANE,
  BOAT: icons["a" /* ICONS */].BOAT
};
function TransportDetailsTravelSection(_ref) {
  var _classnames;

  var firstDeparture = _ref.firstDeparture,
      _ref$hasRefNumberEnab = _ref.hasRefNumberEnabled,
      hasRefNumberEnabled = _ref$hasRefNumberEnab === void 0 ? false : _ref$hasRefNumberEnab,
      onClickCopy = _ref.onClickCopy,
      travelSection = _ref.travelSection;
  var arrival = travelSection.arrival,
      _travelSection$attend = travelSection.attendees,
      attendees = _travelSection$attend === void 0 ? [] : _travelSection$attend,
      connectionDurationInMin = travelSection.connectionDurationInMin,
      departure = travelSection.departure,
      stopDurationInMin = travelSection.stopDurationInMin,
      technicalStops = travelSection.technicalStops,
      transport = travelSection.transport;
  var transportLabel = computeTransportLabel(travelSection.transport);
  var isTrain = transport.type === 'TRAIN';
  return TransportDetailsTravelSection_jsx("div", {
    "data-testid": "TransportDetailsTravelSection"
  }, stopDurationInMin && TransportDetailsTravelSection_jsx(TransportDetailsTravelSectionStop, {
    type: "stop",
    durationInMin: stopDurationInMin
  }), connectionDurationInMin && TransportDetailsTravelSection_jsx(TransportDetailsTravelSectionStop, {
    type: "connection",
    durationInMin: connectionDurationInMin
  }), TransportDetailsTravelSection_jsx("div", {
    className: "flex items-center gap-10"
  }, TransportDetailsTravelSection_jsx("span", {
    className: "text-12 text-darkGrey"
  }, transportLabel), TransportDetailsTravelSection_jsx(Icon["a" /* Icon */], {
    name: transportTypeToIcon[transport.type || 'PLANE'],
    width: "1.5rem"
  })), TransportDetailsTravelSection_jsx("div", {
    className: "ms-30 mt-10"
  }, TransportDetailsTravelSection_jsx("ul", {
    className: "list-none no-underline"
  }, TransportDetailsTravelSection_jsx("li", {
    className: Object(classnames_utils["a" /* classnames */])('relative', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, 'before:absolute before:left-[-25px] before:top-[7px] before:h-[11px] before:w-[11px] before:rounded-full before:border before:border-black before:content-[""]', true), Object(defineProperty["a" /* default */])(_classnames, 'after:absolute after:left-[-20px] after:top-[17px] after:h-[calc(100%+10px)] after:border-l after:border-black after:content-[""]', true), _classnames))
  }, TransportDetailsTravelSection_jsx(TransportDetailsTravelSectionBound, {
    isDeparture: true,
    travelSectionBound: departure,
    firstDeparture: firstDeparture
  }), technicalStops && technicalStops !== '0' && !isTrain && TransportDetailsTravelSection_jsx(TransportDetailsTravelSectionStop, {
    type: "technicalStop"
  })), TransportDetailsTravelSection_jsx("li", {
    className: Object(classnames_utils["a" /* classnames */])('relative mt-20', Object(defineProperty["a" /* default */])({}, 'before:absolute before:left-[-25px] before:top-[7px] before:h-[11px] before:w-[11px] before:rounded-full before:border before:border-black before:content-[""]', true))
  }, TransportDetailsTravelSection_jsx(TransportDetailsTravelSectionBound, {
    isDeparture: false,
    travelSectionBound: arrival,
    firstDeparture: firstDeparture
  })))), hasRefNumberEnabled && TransportDetailsTravelSection_jsx(TransportDetailsTravelSectionReference_TransportDetailsTravelSectionReference, {
    attendees: attendees,
    className: "mt-20",
    onClickCopy: onClickCopy,
    type: transport === null || transport === void 0 ? void 0 : transport.type
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetailsTravelSections.jsx

var TransportDetailsTravelSections_jsx = react_default.a.createElement;



function TransportDetailsTravelSections(_ref) {
  var _ref$hasRefNumberEnab = _ref.hasRefNumberEnabled,
      hasRefNumberEnabled = _ref$hasRefNumberEnab === void 0 ? false : _ref$hasRefNumberEnab,
      onClickCopy = _ref.onClickCopy,
      transportDetailEnriched = _ref.transportDetailEnriched;
  var travelSections = (transportDetailEnriched.travelSections || []).map(function (travelSection, index) {
    return TransportDetailsTravelSections_jsx(TransportDetailsTravelSection, {
      firstDeparture: transportDetailEnriched.departure,
      hasRefNumberEnabled: hasRefNumberEnabled,
      key: "TransportDetailsTravelSection-".concat(index * 2),
      onClickCopy: onClickCopy,
      travelSection: travelSection
    });
  });
  return TransportDetailsTravelSections_jsx("div", {
    "data-testid": "TransportDetailsTravelSections",
    className: "bg-lightSand p-20"
  }, travelSections, TransportDetailsTravelSections_jsx(TransportDetailsWarning_TransportDetailsWarning, {
    transportDetailEnriched: transportDetailEnriched
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/be-transport-details/transport-details/TransportDetails.jsx




var TransportDetails_jsx = react_default.a.createElement;














function TransportDetails(_ref) {
  var _ref$hasRefNumberEnab = _ref.hasRefNumberEnabled,
      hasRefNumberEnabled = _ref$hasRefNumberEnab === void 0 ? false : _ref$hasRefNumberEnab,
      isInbound = _ref.isInbound,
      onClickCopy = _ref.onClickCopy,
      onClickToggle = _ref.onClickToggle,
      theme = _ref.theme,
      transportDetail = _ref.transportDetail;
  var airportIds = [];
  var departureIds = [];
  var arrivalIds = [];
  var companyOperatorsName = Object(transportUtils["j" /* getCompanyOperatorsName */])(transportDetail.travelSections);
  var hasManyCompanies = companyOperatorsName.length > 1;
  var transportDetailEnriched = Object(transport_transportUtils["b" /* computeTransportDetailEnriched */])(transportDetail);

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      toggleDetails = _React$useState2[0],
      setToggleDetails = _React$useState2[1];

  var thTransportWrapper = Object(BeTransportDetails_themes["a" /* themes */])()[theme].thTransportWrapper;
  transportDetail.travelSections.forEach(function (flightNode, index) {
    if (!isEmpty_default()(flightNode)) {
      if (index !== 0) {
        airportIds.push(flightNode.departure.id);
      }

      arrivalIds.push(flightNode.arrival.id);
      departureIds.push(flightNode.departure.id);
    }
  });

  if (!transportDetailEnriched.transport) {
    return null;
  }

  return TransportDetails_jsx("div", {
    "data-testid": "".concat(isInbound ? 'Inbound' : 'Outbound', "TransportDetails")
  }, TransportDetails_jsx("div", {
    className: "px-20"
  }, TransportDetails_jsx(TransportDetailsTravelDates, {
    transportDetailEnriched: transportDetailEnriched,
    isInbound: isInbound
  }), TransportDetails_jsx("div", {
    className: thTransportWrapper
  }, TransportDetails_jsx(TransportDetailsCompanyLogo_TransportDetailsCompanyLogo, {
    companyOperator: transportDetailEnriched.transport.companyOperator,
    manyCompanies: hasManyCompanies,
    theme: theme
  }), TransportDetails_jsx(TransportDetailsItinerary, {
    theme: theme,
    transportDetailEnriched: transportDetailEnriched
  })), TransportDetails_jsx("div", {
    className: "mb-10 flex items-center justify-between"
  }, TransportDetails_jsx(TransportDetailsOperator_TransportDetailsOperator, {
    theme: theme,
    transportDetailEnriched: transportDetailEnriched,
    companyOperatorsName: companyOperatorsName
  }), TransportDetails_jsx("button", {
    type: "button",
    onClick: function onClick() {
      onClickToggle === null || onClickToggle === void 0 ? void 0 : onClickToggle(toggleDetails);
      setToggleDetails(!toggleDetails);
    },
    className: "flex items-center gap-4",
    "data-testid": "ToggleDetailsButton"
  }, TransportDetails_jsx("span", {
    className: "text-14 font-semibold underline"
  }, Object(src_i18n["h" /* t */])('common.details')), TransportDetails_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_TOP,
    rotation: toggleDetails ? 0 : 180
  })))), TransportDetails_jsx(lib["UnmountClosed"], {
    isOpened: toggleDetails
  }, TransportDetails_jsx(TransportDetailsTravelSections, {
    hasRefNumberEnabled: hasRefNumberEnabled,
    onClickCopy: onClickCopy,
    theme: theme,
    transportDetailEnriched: transportDetailEnriched
  })), TransportDetails_jsx("div", {
    className: "px-20 pb-20 pt-10"
  }, TransportDetails_jsx(TransportDetailsTransportInfos_TransportDetailsTransportInfos, {
    theme: theme,
    transportDetailEnriched: transportDetailEnriched
  })));
}

/***/ }),

/***/ "gzwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHILDCARE_STOCK_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BABY_CM_CHILDCARE_MIN_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PETIT_CM_CHILDCARE_MIN_AGE; });
var CHILDCARE_STOCK_THRESHOLD = 10;
var BABY_CM_CHILDCARE_MIN_AGE = 4;
var PETIT_CM_CHILDCARE_MIN_AGE = 24;

/***/ }),

/***/ "kD1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfigWithNoThirdPartySupport; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1mr4");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_11__);










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



 // makes inexact to allow other query params

var shouldIgnoreThirdParty = function shouldIgnoreThirdParty(queryParams) {
  return lodash_has__WEBPACK_IMPORTED_MODULE_9___default()(queryParams, _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["appQueryParameters"].noThirdParty);
};

var appLocaleConfig;
var getConfigWithNoThirdPartySupport = function getConfigWithNoThirdPartySupport(_ref) {
  var name = _ref.name,
      locale = _ref.locale,
      queryParams = _ref.queryParams; // cache if on browser

  if (!appLocaleConfig || false) {
    appLocaleConfig = _config__WEBPACK_IMPORTED_MODULE_11___default.a.locale(locale);
  }

  var originalConfig = appLocaleConfig.get(name);
  return shouldIgnoreThirdParty(queryParams) ? _objectSpread(_objectSpread({}, originalConfig), {}, {
    enabled: false
  }) : originalConfig;
};

/***/ }),

/***/ "pciL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AccommodationRoomInfos_AccommodationRoomInfos; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/widgets/radio-button-with-icon/RadioButtonWithIcon.jsx
var RadioButtonWithIcon = __webpack_require__("dm5U");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-room/infos/constants.js
var infos_constants = __webpack_require__("/1vS");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.utils.js
var AccommodationRoomInfos_utils = __webpack_require__("OsvN");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/infos/FiltersPopin.jsx






var __jsx = react_default.a.createElement;




















var FiltersPopin_FiltersPopin = function FiltersPopin(_ref) {
  var _alternativeByCategor, _alternativeByCategor2, _alternativeByCategor3, _proposal$accommodati, _proposal$accommodati2, _proposal$accommodati3, _proposal$accommodati4;

  var type = _ref.type,
      onClose = _ref.onClose,
      proposal = _ref.proposal;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var resort = Object(es["e" /* useSelector */])(booking_selector["j" /* getCurrentResort */]);
  var isLoading = Object(es["e" /* useSelector */])(booking_selector["r" /* getIsLoadingFilteredAccommodationsAlternativesByComfort */]);
  var alternatives = Object(es["e" /* useSelector */])(booking_selector["m" /* getFilteredAccommodationsAlternativesByComfort */]);
  var proposalCategoryId = proposal.accommodations[0].categoryId.toString();
  var alternativeByCategory = alternatives === null || alternatives === void 0 ? void 0 : alternatives.find(function (_ref2) {
    var categoryId = _ref2.categoryId;
    return categoryId === proposalCategoryId;
  });
  var accommodationsSets = Object(es["e" /* useSelector */])(booking_selector["a" /* getAdditionalAccommodations */]) || [];

  if (isLoading) {
    return __jsx(Modal["a" /* Modal */], {
      ariaLabelledby: identifiers_constants["z" /* ID_MODAL_HEADER__FILTERS */],
      className: "overflow-hidden p-20",
      onClose: onClose
    }, __jsx("div", {
      className: "flex items-center justify-center"
    }, __jsx(Spinner["a" /* Spinner */], {
      size: "medium",
      iconName: icons["a" /* ICONS */].TRIDENT1
    })));
  } // typed filters


  var filtersView = Object(AccommodationRoomInfos_utils["h" /* addViewIconPropertiesToFilters */])(alternativeByCategory === null || alternativeByCategory === void 0 ? void 0 : (_alternativeByCategor = alternativeByCategory.availableFilters) === null || _alternativeByCategor === void 0 ? void 0 : _alternativeByCategor.view);
  var filtersOutsideFacilities = Object(AccommodationRoomInfos_utils["f" /* addOutsideFacilitiesIconPropertiesToFilters */])(alternativeByCategory === null || alternativeByCategory === void 0 ? void 0 : (_alternativeByCategor2 = alternativeByCategory.availableFilters) === null || _alternativeByCategor2 === void 0 ? void 0 : _alternativeByCategor2.outsideFacilities);
  var filtersRoomType = Object(AccommodationRoomInfos_utils["g" /* addRoomTypeIconPropertiesToFilters */])(alternativeByCategory === null || alternativeByCategory === void 0 ? void 0 : (_alternativeByCategor3 = alternativeByCategory.availableFilters) === null || _alternativeByCategor3 === void 0 ? void 0 : _alternativeByCategor3.roomType, resort); // get the adequate type filters

  var filters = Object(AccommodationRoomInfos_utils["k" /* getTypedFilters */])({
    filtersView: filtersView,
    filtersOutsideFacilities: filtersOutsideFacilities,
    filtersRoomType: filtersRoomType
  }, type); // popin type

  var isViewPopin = type === infos_constants["a" /* popinTypes */].VIEW;
  var isOutsideFacilitiesPopin = type === infos_constants["a" /* popinTypes */].OUTSIDE_FACILITIES;
  var isRoomTypePopin = type === infos_constants["a" /* popinTypes */].ROOM_TYPE; // Default Accommodation props :
  // View

  var defaultAccommodationView = ((_proposal$accommodati = proposal.accommodations[0]) === null || _proposal$accommodati === void 0 ? void 0 : _proposal$accommodati.view) || {
    id: AccommodationRoomInfos_utils["e" /* NO_VIEW_ICON_ID */],
    label: Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noViewLabel')
  };
  var defaultAccommodationViewId = defaultAccommodationView === null || defaultAccommodationView === void 0 ? void 0 : defaultAccommodationView.id;
  var defaultAccommodationHasView = !!defaultAccommodationViewId && defaultAccommodationViewId !== AccommodationRoomInfos_utils["e" /* NO_VIEW_ICON_ID */];
  var defaultAccommodationViewIcon = Object(BookingAccommodationsUtils["g" /* getViewIconItem */])(defaultAccommodationView); // Outside facilities

  var defaultAccommodationOutsideFacility = ((_proposal$accommodati2 = proposal.accommodations[0]) === null || _proposal$accommodati2 === void 0 ? void 0 : (_proposal$accommodati3 = _proposal$accommodati2.outsideFacilities) === null || _proposal$accommodati3 === void 0 ? void 0 : _proposal$accommodati3[0]) || {
    id: AccommodationRoomInfos_utils["d" /* NO_OUTSIDE_FACILITY_ICON_ID */],
    label: Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noFacilitiesLabel')
  };
  var defaultAccommodationOutsideFacilityId = defaultAccommodationOutsideFacility === null || defaultAccommodationOutsideFacility === void 0 ? void 0 : defaultAccommodationOutsideFacility.id;
  var defaultAccommodationHasOutsideFacilities = !!defaultAccommodationOutsideFacilityId && defaultAccommodationOutsideFacilityId !== AccommodationRoomInfos_utils["d" /* NO_OUTSIDE_FACILITY_ICON_ID */];
  var defaultAccommodationOutsideFacilitiesIcon = defaultAccommodationOutsideFacility ? Object(BookingAccommodationsUtils["e" /* getOutsideFacilitiesIconItem */])([defaultAccommodationOutsideFacility]) : null; // Room type

  var defaultAccommodationRoomType = (_proposal$accommodati4 = proposal.accommodations[0]) === null || _proposal$accommodati4 === void 0 ? void 0 : _proposal$accommodati4.roomType; // equals Id

  var defaultAccommodationRoomTypeIcon = Object(BookingAccommodationsUtils["f" /* getSurfaceIconItem */])(defaultAccommodationRoomType, resort, proposal.accommodations[0].surface || '35m'); // current accommodation has nothing from current filter

  var defaultAccommodationHasNothing = !defaultAccommodationHasView && isViewPopin || !defaultAccommodationHasOutsideFacilities && isOutsideFacilitiesPopin; // add no extra features radio button

  if (defaultAccommodationHasNothing) {
    // IMPORTANT HINT : We always have a default roomType so this part only concerns the view and the outside facilities
    var noOptionTypedItem = {
      id: isViewPopin ? AccommodationRoomInfos_utils["e" /* NO_VIEW_ICON_ID */] : AccommodationRoomInfos_utils["d" /* NO_OUTSIDE_FACILITY_ICON_ID */],
      title: isViewPopin ? Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noViewLabel') : Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noFacilitiesLabel'),
      icon: {
        icon: isViewPopin ? AccommodationRoomInfos_utils["e" /* NO_VIEW_ICON_ID */] : AccommodationRoomInfos_utils["d" /* NO_OUTSIDE_FACILITY_ICON_ID */],
        labels: isViewPopin ? [Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noViewLabel')] : [Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noFacilitiesLabel')]
      },
      firstAlternativeId: '',
      label: ''
    }; // add this item in the beginning of the array

    filters.unshift(noOptionTypedItem);
  } // get the initially selected ID


  var getInitiallySelectedId = function getInitiallySelectedId() {
    if (defaultAccommodationHasNothing) {
      return isViewPopin ? AccommodationRoomInfos_utils["e" /* NO_VIEW_ICON_ID */] : AccommodationRoomInfos_utils["d" /* NO_OUTSIDE_FACILITY_ICON_ID */];
    }

    if (isViewPopin) {
      return defaultAccommodationViewId;
    }

    if (isOutsideFacilitiesPopin) {
      return defaultAccommodationOutsideFacilityId;
    }

    if (isRoomTypePopin) {
      return defaultAccommodationRoomType;
    }
  };

  var initiallySelectedId = getInitiallySelectedId();
  var shouldShowNoPersonalizationMessage = true; // Tracking

  var computeOptionCategory = function computeOptionCategory() {
    if (isViewPopin) {
      return 'room_view';
    }

    if (isOutsideFacilitiesPopin) {
      return 'room_facility';
    }

    if (isRoomTypePopin) {
      return 'room_configuration';
    }

    return '';
  };

  return __jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      selectedFilterValueId: initiallySelectedId
    }
  }, function (formik) {
    var handleClickValidate = function handleClickValidate() {
      var optionCategory = computeOptionCategory();

      var trackRoomPersonalization = function trackRoomPersonalization(action) {
        trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
          detail_click: "".concat(action, "_room_personalization"),
          room_personalization: optionCategory
        });
      };

      Object(AccommodationRoomInfos_utils["i" /* chooseOption */])({
        appContext: appContext,
        formik: formik,
        filters: filters,
        accommodationsSets: accommodationsSets,
        proposal: proposal,
        resort: resort,
        optionCategory: optionCategory,
        dispatch: dispatch,
        onClose: onClose,
        trackRoomPersonalization: trackRoomPersonalization
      });
    };

    var title = Object(i18n["h" /* t */])(Object(AccommodationRoomInfos_utils["j" /* getTitle */])(type));
    return __jsx(Modal["a" /* Modal */], {
      ariaLabelledby: identifiers_constants["z" /* ID_MODAL_HEADER__FILTERS */],
      className: "overflow-hidden p-20",
      onClose: onClose
    }, __jsx(Title["a" /* Title */], {
      className: "mb-20 justify-center",
      id: identifiers_constants["z" /* ID_MODAL_HEADER__FILTERS */],
      theme: "title-brand-n2"
    }, title), __jsx("ul", {
      className: Object(classnames_utils["a" /* classnames */])('mb-20 flex flex-wrap gap-10', {
        'justify-center': filters.length < 4,
        'justify-between': filters.length >= 4
      })
    }, isViewPopin && defaultAccommodationView && __jsx(AccommodationRoomInfos_utils["c" /* DefaultAccommodationViewRadioButton */], {
      defaultAccommodationViewIcon: defaultAccommodationViewIcon,
      value: defaultAccommodationView.id
    }), isOutsideFacilitiesPopin && defaultAccommodationOutsideFacility && __jsx(AccommodationRoomInfos_utils["a" /* DefaultAccommodationOutsideFacilitiesRadioButton */], {
      defaultAccommodationOutsideFacilitiesIcon: defaultAccommodationOutsideFacilitiesIcon,
      value: defaultAccommodationOutsideFacility.id
    }), isRoomTypePopin && defaultAccommodationRoomType && __jsx(AccommodationRoomInfos_utils["b" /* DefaultAccommodationRoomTypeRadioButton */], {
      defaultAccommodationRoomTypeIcon: defaultAccommodationRoomTypeIcon,
      value: defaultAccommodationRoomType
    }), filters === null || filters === void 0 ? void 0 : filters.map(function (_ref3, index) {
      var _accommodationsSets$f, _accommodationsSets$f2;

      var filterId = _ref3.id,
          icon = _ref3.icon,
          firstAlternativeId = _ref3.firstAlternativeId;
      // get the price diff
      var priceDifference = (_accommodationsSets$f = accommodationsSets.find(function (_ref4) {
        var id = _ref4.id;
        return id === firstAlternativeId;
      })) === null || _accommodationsSets$f === void 0 ? void 0 : (_accommodationsSets$f2 = _accommodationsSets$f.totalDifferentialPrice) === null || _accommodationsSets$f2 === void 0 ? void 0 : _accommodationsSets$f2.value; // +XXX or -XXX

      var formattedPrice = Object(proposalUtils["e" /* getFormatedPriceByLocale */])(priceDifference, appContext.locale, proposal.price.currency); // here we dont show the alternative of the same type as the current accommodation

      if (isViewPopin && defaultAccommodationViewId !== filterId || isOutsideFacilitiesPopin && defaultAccommodationOutsideFacilityId !== filterId || isRoomTypePopin && defaultAccommodationRoomType !== filterId) {
        var _formik$values, _icon$labels;

        shouldShowNoPersonalizationMessage = false;
        return __jsx("li", {
          className: "w-150 flex-none",
          key: index
        }, __jsx(RadioButtonWithIcon["a" /* RadioButtonWithIcon */], {
          isChecked: (formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.selectedFilterValueId) === filterId,
          name: "selectedFilterValueId",
          title: icon.labels[0],
          icon: icon.icon,
          description: ((_icon$labels = icon.labels) === null || _icon$labels === void 0 ? void 0 : _icon$labels[1]) || '',
          value: filterId,
          priceDifference: formattedPrice
        }));
      }
    }), shouldShowNoPersonalizationMessage && __jsx("li", {
      className: "flex w-150 flex-none items-center justify-center"
    }, Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noPersonalizationErrorMessage'))), __jsx("div", {
      className: "-mx-20 mt-20 flex justify-center border-t-1 border-lightGrey pt-20"
    }, __jsx(Button["a" /* Button */], {
      onClick: handleClickValidate
    }, Object(i18n["h" /* t */])('booking.common.validate'))));
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var AccommodationRoomInfos_themes_getSmallStyles = function getSmallStyles(isExclusiveCollection) {
  return {
    thTitle: 'font-brand mt-40 mb-0 text-center text-ultramarine',
    thList: Object(classnames_utils["a" /* classnames */])(' flex text-10', {
      'flex-wrap': isExclusiveCollection
    }),
    thListItem: Object(classnames_utils["a" /* classnames */])('flex-none px-5', {
      'w-1/4': !isExclusiveCollection
    }, {
      'w-1/2': isExclusiveCollection
    }),
    thItem: Object(classnames_utils["a" /* classnames */])('border-lightGrey flex flex-col font-sans h-full items-center justify-center font-bold leading-normal overflow-hidden p-10 px-0 rounded-12 text-center', {
      'border-1 text-10 text-black': !isExclusiveCollection
    }, {
      'border-0 text-12 text-ultramarine': isExclusiveCollection
    }),
    thIcon: 'mb-10',
    thIconWidth: isExclusiveCollection ? '3.6em' : '2em',
    thText: 'font-bold leading-tight w-full',
    thCTA: 'mt-5 text-10'
  };
};

var AccommodationRoomInfos_themes_themes = function themes(isExclusiveCollection) {
  var small = AccommodationRoomInfos_themes_getSmallStyles(isExclusiveCollection);
  return {
    "default": small,
    medium: _objectSpread(_objectSpread({}, small), {}, {
      thTitle: Object(classnames_utils["a" /* classnames */])(small.thTitle, 'sm:mt-50'),
      thListItem: Object(classnames_utils["a" /* classnames */])(small.thListItem, {
        'sm:w-1/5': !isExclusiveCollection
      }, {
        'sm:w-1/2': isExclusiveCollection
      }),
      thItem: Object(classnames_utils["a" /* classnames */])(small.thItem, 'sm:px-5 md:px-10 md:py-20 md:text-12')
    }),
    large: {
      thTitle: Object(classnames_utils["a" /* classnames */])(small.thTitle, 'sm:mt-50'),
      thList: small.thList,
      thListItem: Object(classnames_utils["a" /* classnames */])(small.thListItem, {
        'md:w-1/6': !isExclusiveCollection
      }, {
        'sm:w-1/3': isExclusiveCollection
      }),
      thItem: Object(classnames_utils["a" /* classnames */])(small.thItem, 'sm:px-5 md:px-10 md:py-20 md:text-12'),
      thIcon: small.thIcon,
      thIconWidth: small.thIconWidth,
      thText: small.thText,
      thCTA: small.thCTA
    },
    column: {
      thList: 'p-0 m-0 list-none',
      thItem: 'border-none text-14 mt-10',
      thIcon: 'mr-20 text-black',
      thText: 'mr-5'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.jsx





var AccommodationRoomInfos_jsx = react_default.a.createElement;


















var WIDTH = 108;
var AccommodationRoomInfos_AccommodationRoomInfos = function AccommodationRoomInfos(_ref) {
  var className = _ref.className,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      _ref$isFilterableInfo = _ref.isFilterableInfoList,
      isFilterableInfoList = _ref$isFilterableInfo === void 0 ? false : _ref$isFilterableInfo,
      isInMoreRoomLayer = _ref.isInMoreRoomLayer,
      isAccommodationSummary = _ref.isAccommodationSummary,
      _ref$isScrollable = _ref.isScrollable,
      isScrollable = _ref$isScrollable === void 0 ? true : _ref$isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      proposal = _ref.proposal,
      _ref$roomCategoryId = _ref.roomCategoryId,
      roomCategoryId = _ref$roomCategoryId === void 0 ? '' : _ref$roomCategoryId,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["i" /* getCurrentProposal */]);
  var alternatives = Object(es["e" /* useSelector */])(booking_selector["m" /* getFilteredAccommodationsAlternativesByComfort */]);
  var currentComfortAlternatives = alternatives === null || alternatives === void 0 ? void 0 : alternatives.find(function (_ref2) {
    var categoryId = _ref2.categoryId;
    return categoryId === roomCategoryId;
  });

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var _useState = Object(react["useState"])(null),
      popinType = _useState[0],
      setPopinType = _useState[1];

  var router = Object(next_router["useRouter"])();
  var isNotComparatorView = router.pathname !== '/comparator';
  var notComparatorNorLayer = !isInMoreRoomLayer && isNotComparatorView;
  var proposals = Object(es["e" /* useSelector */])(booking_selector["t" /* getProposals */]); // those elements should use the selectedProposalId because as in cefalu we open the deluxe byDefault
  // on the other hand the comparator has no selectedProposalId get param

  var selectedProposalId = isNotComparatorView ? router.query.selectedProposalId : selectedProposal.id;
  var selectedProposalForFiltersPopin = notComparatorNorLayer ? proposals.find(function (_ref3) {
    var id = _ref3.id;
    return id === router.query.selectedProposalId;
  }) : selectedProposal;
  var _themes$theme = AccommodationRoomInfos_themes_themes(isExclusiveCollection)[theme],
      thTitle = _themes$theme.thTitle,
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thText = _themes$theme.thText,
      thCTA = _themes$theme.thCTA; // Filters Pop In Management

  var _React$useState = react_default.a.useState(false),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      isOpenedPopIn = _React$useState2[0],
      setIsOpenedPopIn = _React$useState2[1];

  var closePopIn = function closePopIn() {
    return setIsOpenedPopIn(false);
  };

  var openPopIn = function openPopIn(icon) {
    if (Object(AccommodationRoomInfos_utils["o" /* isRoomTypeItem */])(icon)) {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'room_perso_room_configuration'
      });
      setPopinType(infos_constants["a" /* popinTypes */].ROOM_TYPE);
    }

    if (Object(AccommodationRoomInfos_utils["p" /* isViewItem */])(icon)) {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'room_perso_room_view'
      });
      setPopinType(infos_constants["a" /* popinTypes */].VIEW);
    }

    if (Object(AccommodationRoomInfos_utils["n" /* isOutsideFacilityItem */])(icon)) {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION, {
        detail_click: 'room_perso_room_facilities'
      });
      setPopinType(infos_constants["a" /* popinTypes */].OUTSIDE_FACILITIES);
    }

    setIsOpenedPopIn(true);
  };

  var uri = new URI_default.a(router.asPath);
  var pathname = uri.pathname();
  var isOption = pathname.startsWith('/option');
  var isConfirmation = pathname === '/confirmation';
  var Component = isScrollable ? Scrollable["a" /* Scrollable */] : 'div';
  var componentProps = isScrollable ? {
    backwardLabel: Object(i18n["h" /* t */])('common.scrollBackward'),
    className: className,
    deltaScrollFactorClick: WIDTH,
    elementWidth: WIDTH,
    forwardLabel: Object(i18n["h" /* t */])('common.scrollForward'),
    navPosition: 'center'
  } : {
    className: className
  };
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isAlternativeFiltersModeActive = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.AlternativeFiltersModeActive');
  var resort = selectedProposal.resort;
  var shouldShowPopin = notComparatorNorLayer && // not the comparator view nor more room layer
  isFilterableInfoList && // only the first List of items
  isOpenedPopIn && // on/off
  isAlternativeFiltersModeActive && // featureFlip
  (proposal === null || proposal === void 0 ? void 0 : proposal.id) === selectedProposalId; // Accommodations tabs

  var hasAtLeastOneAlternativeOfAnyType = items.reduce(function (prev, _ref4) {
    var icon = _ref4.icon;
    return prev || Object(AccommodationRoomInfos_utils["m" /* isItemFilterable */])(icon) && Object(AccommodationRoomInfos_utils["l" /* hasTypedAlternative */])({
      currentComfortAlternatives: currentComfortAlternatives,
      icon: icon,
      proposal: proposal
    });
  }, false);
  var shouldShowPersonalizeYourRoomTitle = notComparatorNorLayer && isAlternativeFiltersModeActive && hasAtLeastOneAlternativeOfAnyType && isFilterableInfoList;
  return AccommodationRoomInfos_jsx(Component, componentProps, shouldShowPopin && AccommodationRoomInfos_jsx(FiltersPopin_FiltersPopin, {
    onClose: closePopIn,
    proposal: selectedProposalForFiltersPopin,
    resort: resort,
    type: popinType
  }), isExclusiveCollection && AccommodationRoomInfos_jsx("h3", {
    className: thTitle
  }, Object(i18n["h" /* t */])('booking.accommodation.exclusiveCollectionServices')), shouldShowPersonalizeYourRoomTitle && AccommodationRoomInfos_jsx("div", {
    className: "mb-10 font-brand text-16"
  }, Object(i18n["h" /* t */])('booking.accommodation.roomFinder.filtersTitle')), AccommodationRoomInfos_jsx("ul", {
    className: thList
  }, items.map(function (_ref5, idx) {
    var icon = _ref5.icon,
        _ref5$labels = _ref5.labels,
        labels = _ref5$labels === void 0 ? [] : _ref5$labels,
        _ref5$buttonText = _ref5.buttonText,
        buttonText = _ref5$buttonText === void 0 ? undefined : _ref5$buttonText;
    return AccommodationRoomInfos_jsx("li", {
      className: thListItem,
      key: idx,
      style: {
        width: !isExclusiveCollection && (isOption || isConfirmation || isAccommodationSummary) || !isScrollable ? null : WIDTH
      }
    }, AccommodationRoomInfos_jsx("div", {
      className: thItem
    }, AccommodationRoomInfos_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])({
        'flex-1': isOption || isConfirmation || isAccommodationSummary,
        flex: isOption || isConfirmation || isAccommodationSummary
      })
    }, AccommodationRoomInfos_jsx(Icon["a" /* Icon */], {
      className: thIcon,
      name: icon,
      width: thIconWidth
    }), labels.map(function (label) {
      return AccommodationRoomInfos_jsx("div", {
        className: thText,
        key: label
      }, label);
    })), isFilterableInfoList && notComparatorNorLayer && isAlternativeFiltersModeActive && Object(AccommodationRoomInfos_utils["m" /* isItemFilterable */])(icon) && Object(AccommodationRoomInfos_utils["l" /* hasTypedAlternative */])({
      currentComfortAlternatives: currentComfortAlternatives,
      icon: icon,
      proposal: proposal
    }) && AccommodationRoomInfos_jsx(Button["a" /* Button */], {
      className: thCTA,
      onClick: function onClick() {
        return openPopIn(icon);
      },
      theme: "link"
    }, buttonText || Object(i18n["h" /* t */])('booking.common.change'))));
  })));
};

/***/ }),

/***/ "vvV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = function themes() {
  return {
    mobile: {
      thWrapper: 'flex flex-col',
      thDashSeparator: 'mx-10',
      thTransportWrapper: 'block mb-5',
      thCompanyLogo: 'my-10',
      thManyCompanies: 'w-1/2 py-10',
      thOperator: 'block',
      thOperatorInfoButton: 'h-20 top-[5px]',
      thItinerary: 'w-3/10',
      thTransportInfos: 'block',
      thLuggage: 'hidden'
    },
    desktop: {
      thWrapper: 'flex flex-row',
      thDashSeparator: 'my-10',
      thTransportWrapper: 'flex items-center justify-stretch mb-5',
      thCompanyLogo: 'w-1/5',
      thManyCompanies: 'w-full py-15',
      thOperator: 'flex items-center',
      thOperatorInfoButton: 'h-20',
      thItinerary: 'w-1/5',
      thTransportInfos: 'flex',
      thLuggage: 'inline-block'
    }
  };
};

/***/ }),

/***/ "wKck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CopyButton; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;





var CopyButton = function CopyButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      copiedLabel = _ref.copiedLabel,
      _onClick = _ref.onClick,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "copiedLabel", "onClick"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isCopied = _useState[0],
      setIsCopied = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var timer;

    if (isCopied) {
      timer = setTimeout(function () {
        return setIsCopied(false);
      }, 2000);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [isCopied]);

  if (!react__WEBPACK_IMPORTED_MODULE_2__["Children"].count(children)) {
    return null;
  }

  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_5__[/* classnames */ "a"])('relative isolate inline-flex items-center', className)
  }, __jsx("button", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: "inline-flex items-center gap-5 rounded-pill bg-lightSand px-10 py-2 text-16 font-bold",
    onClick: function onClick() {
      navigator.clipboard.writeText(children);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      setIsCopied(true);
    },
    title: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "h"])('booking.common.copyPaste'),
    type: "button"
  }), __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].COPY_LINK
  }), children), isCopied && __jsx("span", {
    className: "animation-duration-250 absolute start-full mx-5 flex animate-fadeIn items-center whitespace-nowrap rounded-pill bg-white/80 px-5 py-2 text-12 font-bold text-green"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "shrink-0",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].CHECK_FILLED
  }), copiedLabel));
};

/***/ })

}]);